import { Box, Container, Heading, Icon, SimpleGrid, Square, Stack, Text } from "@chakra-ui/react";
import { AiFillAudio } from "react-icons/ai";
import { BsStars } from "react-icons/bs";
import { HiLanguage } from "react-icons/hi2";
import { MdLanguage } from "react-icons/md";
import { TiMessages } from "react-icons/ti";
import { FaChalkboardTeacher, FaFireAlt, FaUsers } from "react-icons/fa";
import { RiTranslate } from "react-icons/ri";
import { FiBook } from "react-icons/fi";
import { LandingLocale } from "../localization/landing";
import { BiStats } from "react-icons/bi";
import { TbMessages } from "react-icons/tb";

interface Props {
  l: LandingLocale;
}

export function FeaturesB2B({ l }: Props) {
  const features = [
    {
      name: "Voice Conversations",
      description: "Let your students practice speaking with our AI tutors",
      icon: TiMessages,
    },
    {
      name: "Pronunciation",
      description: "Full access to our pronunciation practice tool",
      icon: AiFillAudio,
    },
    {
      name: "Feedback & Translations",
      description:
        "Students get immediate translations and feedback on how to improve their sentences",
      icon: RiTranslate,
    },
    {
      name: "Multiple Languages and Dialects",
      description:
        "Allow all 134 languages and dialects available or limit the languages to the ones you need",
      icon: MdLanguage,
    },
    {
      name: "Progress",
      description: "Track your students' progress and help them stay on track",
      icon: BiStats,
    },
    {
      name: "Wordbook & Flashcards",
      description: "Students can save words and practice them with flashcards",
      icon: FiBook,
    },
    {
      name: "Multi-user management",
      description: "Manage all your students' accounts from a single dashboard",
      icon: FaUsers,
    },
    {
      name: "Custom content",
      description: "Create custom topics & scenarios for your students to practice",
      icon: FaChalkboardTeacher,
    },
    {
      name: "Customizable AI Tutors",
      description: "Create your own AI tutors with specific personalities and accents",
      icon: BsStars,
    },
  ];

  return (
    <Box as="section" bg="bg.surface">
      <Container py={{ base: "16", md: "24" }}>
        <Stack spacing={{ base: "12", md: "16" }}>
          <Stack spacing={{ base: "4", md: "5" }} align="center" textAlign="center">
            <Stack spacing="3">
              <Heading size={{ base: "sm", md: "md" }}>Feature Spotlight</Heading>
            </Stack>
            <Text color="fg.muted" fontSize={{ base: "lg", md: "xl" }} maxW="3xl">
              Navigate our suite of features, designed to take your {"students'"} speaking skills to
              the next level
            </Text>
          </Stack>
          <SimpleGrid
            columns={{ base: 1, md: 2, lg: 3 }}
            columnGap={8}
            rowGap={{ base: 10, md: 16 }}
          >
            {features.map((feature, i) => (
              <Stack key={i} spacing={{ base: "4", md: "5" }} align="center" textAlign="center">
                <Square
                  size={{ base: "10", md: "12" }}
                  bg="brand.primary.main"
                  color="fg.inverted"
                  borderRadius="lg"
                >
                  <Icon as={feature.icon} boxSize={{ base: "5", md: "6" }} />
                </Square>
                <Stack spacing={{ base: "1", md: "2" }}>
                  <Text fontSize={{ base: "lg", md: "xl" }} fontWeight="medium">
                    {feature.name}
                  </Text>
                  <Text color="fg.muted">{feature.description}</Text>
                </Stack>
              </Stack>
            ))}
          </SimpleGrid>
        </Stack>
      </Container>
    </Box>
  );
}
